import IPCCenter from "@js/ipc/index";
import { EVENTCMD } from "@js/events/index";
import { gameWindowPageName } from "@/config";
import stastic from "@js/stastic/index";
import { getCurrentGame } from "@js/account/index";
import router from "@/router";

// 游戏页面
export let gameWind: Window | null = null;

// 检测游戏窗口是否打开
export const checkGameWindOpen = () => {
  return gameWind && !gameWind.closed;
};

// 打开游戏页面
export const handleOpenGameWind = () => {
  // console.log("handleOpenGameWind");
  if (checkGameWindOpen()) {
    gameWind && gameWind.focus();
  } else {
    IPCCenter.getInstance().broadCastEvent(
      EVENTCMD.CloseGameWindowIfNeeded,
      {}
    );

    const target = router.resolve({
      path: `/${gameWindowPageName}`,
    });

    gameWind = window.open(target.href, "_blank");

    stastic.addTrackEvent("游戏启动次数", "game_startup");

    const playingGame = getCurrentGame();

    if (playingGame) {
      stastic.addTrackEvent(
        "单款游戏启动次数",
        "single_game_startup",
        playingGame.name!
      );
    }
  }
};
